<template>
    <div class="financial-sustainability-form1">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group
                label="Faturamento mensal da iniciativa"
                label-for="budget"
                class="required"
                v-if="getProfileId !== 3"
            >
                <b-form-select
                    id="budget"
                    name="budget"
                    v-model="$v.form.budget.selected.$model"
                    :options="form.budget.options"
                    :state="validateState('budget')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['id_orcamento_anual'].value)
                    "
                ></b-form-select>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_orcamento_anual'].value"
                />

                <b-form-invalid-feedback :state="validateState('budget')">
                    Campo obrigatório
                </b-form-invalid-feedback>

                <LockPP
                    :statusLock="form.budgetLock"
                    :lockMsg="'Privado'"
                    :unlockMsg="'Público'"
                    @click="form.budgetLock = Number(!form.budgetLock)"
                    v-if="showLock"
                />
            </b-form-group>

            <b-form-group
                label="Qual é o faturamento mensal da sua iniciativa?"
                label-for="monthlyInvoicing"
                class="required"
                v-if="getProfileId === 3"
            >
                <b-form-select
                    id="monthlyInvoicing"
                    name="monthlyInvoicing"
                    v-model="$v.form.monthlyInvoicing.selected.$model"
                    :options="form.monthlyInvoicing.options"
                    :state="validateState('monthlyInvoicing')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['id_faturamento'].value)
                    "
                ></b-form-select>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_faturamento'].value"
                />

                <b-form-invalid-feedback :state="validateState('monthlyInvoicing')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Equipe dedicada" label-for="hasCounter" class="required">
                <b-form-radio-group
                    id="hasCounter"
                    name="hasCounter"
                    v-model="$v.form.hasCounter.selected.$model"
                    :options="form.hasCounter.options"
                    :state="validateState('hasCounter')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['possui_contador'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['possui_contador'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasCounter')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="A iniciativa tem equipe dedicada para captação de recursos?"
                label-for="hasTeam"
                class="required"
                v-if="getProfileId !== 3"
            >
                <b-form-radio-group
                    id="hasTeam"
                    name="hasTeam"
                    v-model="$v.form.hasTeam.selected.$model"
                    :options="form.hasTeam.options"
                    :state="validateState('hasTeam')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['equipe_captacao_recurso'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['equipe_captacao_recurso'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasTeam')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Como a iniciativa se mantém financeiramente? (marque todas que se aplicam)"
                label-for="financiallyMaintain"
                class="required"
            >
                <b-form-checkbox-group
                    id="financially-maintain"
                    name="financiallyMaintain"
                    v-model="$v.form.financiallyMaintain.selected.$model"
                    :options="form.financiallyMaintain.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('financiallyMaintain')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['iniciativa_mantem'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['iniciativa_mantem'].value"
                />

                <b-form-input
                    name="others"
                    class="col-md-6"
                    v-model="form.others"
                    placeholder="Especifique outros"
                    :disabled="getIsDisabled"
                    v-if="form.financiallyMaintain.selected.includes(15)"
                ></b-form-input>

                <b-form-invalid-feedback :state="validateState('financiallyMaintain')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Fundo reserva" label-for="reserveFund" class="required">
                <b-form-radio-group
                    id="reserveFund"
                    name="reserveFund"
                    v-model="$v.form.reserveFund.selected.$model"
                    :options="form.reserveFund.options"
                    :state="validateState('reserveFund')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['possui_fundo_reserva'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['possui_fundo_reserva'].value"
                />

                <b-form-invalid-feedback :state="validateState('reserveFund')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Esse fundo permite que a iniciativa mantenha suas atividades por quanto tempo?"
                label-for="time"
                class="required"
                v-if="form.reserveFund.selected"
            >
                <b-form-select
                    id="time"
                    name="time"
                    v-model="$v.form.time.selected.$model"
                    :options="form.time.options"
                    :state="validateState('time')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['id_mantenha_atividade_tempo'].value)
                    "
                ></b-form-select>

                <NoAuthorizationMsgPP
                    v-if="
                        isPlatform && getAuthorizationData && !getAuthorizationData['id_mantenha_atividade_tempo'].value
                    "
                />

                <b-form-invalid-feedback :state="validateState('time')">
                    Campo obrigatório
                </b-form-invalid-feedback>

                <LockPP
                    :statusLock="form.timeLock"
                    :lockMsg="'Privado'"
                    :unlockMsg="'Público'"
                    @click="form.timeLock = Number(!form.timeLock)"
                    v-if="showLock"
                />
            </b-form-group>

            <b-form-group
                label="Existe algum endividamento? (bancário, mútuos com sócios ou fiscal)"
                label-for="hasDebts"
                class="required"
                v-if="form.reserveFund.selected === 0"
            >
                <b-form-radio-group
                    id="hasDebts"
                    name="hasDebts"
                    v-model="$v.form.hasDebts.selected.$model"
                    :options="form.hasDebts.options"
                    :state="validateState('hasDebts')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['algum_endividamento'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['algum_endividamento'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasDebts')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'ManagementPlanningForm2' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('ManagementPlanningForm2')"
                        >Voltar</b-button
                    >

                    <b-button
                        :variant="'primary'"
                        @click="changeRegisterForm('NetworksPartnersForm1')"
                        v-if="abbleNextPage"
                    >
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <b-modal
            ref="warning-modal-ref"
            body-class="warning-modal"
            :hide-header="true"
            :hide-footer="true"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <WarningMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="primary" @click="$router.push({ name: 'LoginForm' })">{{
                    $CONTINUAR_PLATAFORMA
                }}</b-button>
                <b-button variant="secondary" @click="nextPage()">Continuar cadastro</b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import LockPP from '@/ui/lock-pp/LockPP'
import WarningMsgModal from '@/ui/modal/warning-msg-modal/WarningMsgModal'
import { FinancialSustainabilityApi } from '../../api/financial-sustainability'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const financialSustainabilityApi = new FinancialSustainabilityApi()

export default {
    components: { DangerModalPP, NoAuthorizationMsgPP, LockPP, WarningMsgModal },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        },
        abbleNextPage: {
            type: Boolean,
            default: false
        },
        showLock: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            progress: 63.71,
            isUpdate: false,
            financialSustainability: null,
            authorizationData: null,
            usuario: null,
            isDisabled: null,
            message: null,
            form: {
                time: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                timeLock: 1,
                budget: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                budgetLock: 1,
                monthlyInvoicing: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                hasCounter: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                hasTeam: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                reserveFund: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                hasDebts: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                financiallyMaintain: {
                    selected: [],
                    options: [
                        { text: 'Eu mesmo coloco grana', item: 1, value: 1, show: true },
                        { text: 'Participo de editais públicos', item: 2, value: 2, show: true },
                        { text: 'Faço campanhas de financiamento coletivo', item: 3, value: 3, show: true },
                        { text: 'Presto serviços', item: 4, value: 4, show: true },
                        { text: 'Faço eventos', item: 5, value: 5, show: true },
                        { text: 'Recebo recurso via leis de incentivo', item: 6, value: 6, show: true },
                        { text: 'Parceria com órgão público', item: 7, value: 7, show: true },
                        { text: 'Recebo recurso via nota fiscal paulista', item: 8, value: 8, show: true },
                        { text: 'Participo de editais de empresas', item: 9, value: 9, show: true },
                        { text: 'Tenho um mantenedor pessoa física', item: 10, value: 10, show: true },
                        {
                            text: 'Participo de editais de Fundações/Institutos/Fundos',
                            item: 11,
                            value: 11,
                            show: true
                        },
                        { text: 'Tenho um mantenedor pessoa jurídica', item: 12, value: 12, show: true },
                        { text: 'Participo de editais internacionais', item: 13, value: 13, show: true },
                        { text: 'Vendo produtos', item: 14, value: 14, show: true },
                        { text: 'Outros (especifique)', item: 15, value: 15, show: true }
                    ]
                },
                others: null
            }
        }
    },
    validations: {
        form: {
            time: {
                selected: {
                    required() {
                        return !(this.form.time.selected === null && this.form.reserveFund.selected)
                    }
                }
            },
            budget: {
                selected: {
                    required() {
                        return !(this.form.budget.selected === null && this.getProfileId !== 3)
                    }
                }
            },
            hasTeam: {
                selected: {
                    required() {
                        return !(this.form.hasTeam.selected === null && this.getProfileId !== 3)
                    }
                }
            },
            monthlyInvoicing: {
                selected: {
                    required() {
                        return !(this.form.monthlyInvoicing.selected === null && this.getProfileId === 3)
                    }
                }
            },
            hasCounter: { selected: { required } },
            reserveFund: { selected: { required } },
            hasDebts: {
                selected: {
                    required() {
                        return !(this.form.hasDebts.selected === null && this.form.reserveFund.selected === 0)
                    }
                }
            },
            financiallyMaintain: { selected: { required } }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress', 'setShowGamificationProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData

            this.form.time.selected = data.id_mantenha_atividade_tempo
            this.form.timeLock =
                data.view_id_mantenha_atividade_tempo === null ? 1 : data.view_id_mantenha_atividade_tempo
            this.form.budget.selected = data.id_orcamento_anual
            this.form.budgetLock = data.view_id_orcamento_anual === null ? 1 : data.view_id_orcamento_anual
            this.form.monthlyInvoicing.selected = data.id_faturamento
            this.form.hasCounter.selected = data.possui_contador
            this.form.hasTeam.selected = data.equipe_captacao_recurso
            this.form.reserveFund.selected = data.possui_fundo_reserva
            this.form.hasDebts.selected = data.algum_endividamento

            this.setIsLoading(true)

            axios
                .all([
                    financialSustainabilityApi.getOrcamentoAnual(),
                    financialSustainabilityApi.getMantenhaAtividade(),
                    financialSustainabilityApi.getFaturamentoMensal()
                ])
                .then(response => {
                    this.form.budget.options.push(
                        ...response[0].data.map(item => ({ value: item.id, text: item.orcamento_anual }))
                    )

                    this.form.time.options.push(...response[1].data.map(item => ({ value: item.id, text: item.tempo })))

                    this.form.monthlyInvoicing.options.push(
                        ...response[2].data.map(item => ({ value: item.id, text: item.faturamento }))
                    )

                    this.form.financiallyMaintain.selected =
                        data.iniciativa_mantem === null
                            ? []
                            : data.iniciativa_mantem.filter(item => typeof item === 'number')

                    this.form.others =
                        data.iniciativa_mantem === null
                            ? null
                            : data.iniciativa_mantem.filter(item => typeof item !== 'number')[0].others

                    this.filterData()
                    this.fetchAuthorization()
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        fetch() {
            if (this.getProgress === '60.94') {
                this.setShowGamificationProgress(true)

                setTimeout(() => {
                    this.setShowGamificationProgress(false)
                }, 12000)
            }

            this.usuario = JSON.parse(localStorage.getItem('usuario'))
            this.setIsLoading(true)

            axios
                .all([
                    financialSustainabilityApi.getFinancialSust(),
                    financialSustainabilityApi.getOrcamentoAnual(),
                    financialSustainabilityApi.getMantenhaAtividade(),
                    financialSustainabilityApi.getFaturamentoMensal()
                ])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.financialSustainability = data
                        this.form.time.selected = data.id_mantenha_atividade_tempo
                        this.form.timeLock =
                            data.view_id_mantenha_atividade_tempo === null ? 1 : data.view_id_mantenha_atividade_tempo
                        this.form.budget.selected = data.id_orcamento_anual
                        this.form.budgetLock = data.view_id_orcamento_anual === null ? 1 : data.view_id_orcamento_anual
                        this.form.monthlyInvoicing.selected = data.id_faturamento
                        this.form.hasCounter.selected = data.possui_contador
                        this.form.hasTeam.selected = data.equipe_captacao_recurso
                        this.form.reserveFund.selected = data.possui_fundo_reserva
                        this.form.hasDebts.selected = data.algum_endividamento

                        this.setProgress(data.percentual)
                    }

                    this.form.budget.options.push(
                        ...response[1].data.map(item => ({ value: item.id, text: item.orcamento_anual }))
                    )

                    this.form.time.options.push(...response[2].data.map(item => ({ value: item.id, text: item.tempo })))

                    this.form.monthlyInvoicing.options.push(
                        ...response[3].data.map(item => ({ value: item.id, text: item.faturamento }))
                    )

                    this.form.financiallyMaintain.selected =
                        data.iniciativa_mantem === null
                            ? []
                            : data.iniciativa_mantem.filter(item => typeof item === 'number')

                    this.form.others =
                        data.iniciativa_mantem === null
                            ? null
                            : data.iniciativa_mantem.filter(item => typeof item !== 'number')[0].others
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress

            const data = {
                ...this.financialSustainability,
                id_mantenha_atividade_tempo: this.form.time.selected,
                view_id_mantenha_atividade_tempo: this.form.timeLock,
                id_orcamento_anual: this.form.budget.selected,
                view_id_orcamento_anual: this.form.budgetLock,
                id_faturamento: this.form.monthlyInvoicing.selected,
                possui_contador: this.form.hasCounter.selected,
                equipe_captacao_recurso: this.form.hasTeam.selected,
                possui_fundo_reserva: this.form.reserveFund.selected,
                algum_endividamento: this.form.hasDebts.selected,
                iniciativa_mantem: this.form.financiallyMaintain.selected,
                percentual: currentProgress
            }

            data.iniciativa_mantem = [...data.iniciativa_mantem, { others: this.form.others }]

            this.setIsLoading(true)
            const request = this.isUpdate
                ? financialSustainabilityApi.updateFinancialSust(data)
                : financialSustainabilityApi.createFinancialSust(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)
                    this.message = response.data.message

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.showModal('warning-modal-ref')
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        nextPage() {
            this.hideModal('warning-modal-ref')
            this.$router.push({ name: 'NetworksPartnersForm1' })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getFinancialSustainability(this.userIdLogged)
                    .then(response => {
                        // if (this.getProfileId === 3) {
                        //     this.$router.push({ name: 'AboutLegalGuardianForm3' })
                        // } else {
                        //     this.showModal('warning-modal-ref')
                        // }

                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        filterData() {
            if (this.receiveData) {
                this.form.financiallyMaintain.options = this.form.financiallyMaintain.options.filter(x =>
                    this.form.financiallyMaintain.selected.includes(x.value)
                )

                this.form.hasCounter.options = this.form.hasCounter.options.filter(
                    x => Number(this.form.hasCounter.selected) === x.value
                )

                this.form.hasTeam.options = this.form.hasTeam.options.filter(
                    x => Number(this.form.hasTeam.selected) === x.value
                )

                this.form.reserveFund.options = this.form.reserveFund.options.filter(
                    x => Number(this.form.reserveFund.selected) === x.value
                )

                this.form.hasDebts.options = this.form.hasDebts.options.filter(
                    x => Number(this.form.hasDebts.selected) === x.value
                )
            }
        }
    },
    computed: {
        getFinanciallyMaintain() {
            return this.form.financiallyMaintain.options.filter(opt =>
                this.getProfileId === 1 ? opt : [1, 2, 3, 4, 9, 10, 11, 12, 13, 14, 15].includes(opt.item)
            )
        },
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProgress() {
            return this.$store.state.progress
        },
        getProfileId() {
            return this.$store.state.profileId
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/register-financial-sustainability/FinancialSustainabilityForm1.vue